import { Component, OnInit } from '@angular/core';
import { Informe } from './informes.model';
import { Router } from '@angular/router';
import { EventService } from 'src/app/core/service/event.service';
import { InformeService } from './informes.service';
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent implements OnInit {
  model = {
    tipoInforme: '',
    year: '',
  };

  years: number[] = [];
  tiposInforme: string[] = [
    'EXCEL_EXPEDIENTES_COMPLETOS',
    'EXCEL_EXPEDIENTES_ACTIVOS_SUSPENDIDOS',
    'EXCEL_EXPEDIENTES_ESTADISTICAS_ANUALES'
  ];

  constructor(
    private eventService: EventService,
    private informeService: InformeService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE, {
      title: 'Informe',
      breadCrumbItems: [{ label: 'Informes', path: '.' }]
    });

    this.informeService.getYears().subscribe({
      next: (response) => {
        this.years = response.sort((a: number, b: number) => b - a);
      },
      error: (err) => {
        console.error('Error al obtener los años disponibles:', err);
      }
    });
  }

  onSubmit(form: NgForm) {
    const informe: Informe = {
      tipoInforme: form.value.tipoInforme,
      year: form.value.year,
    };

    if (informe.tipoInforme && informe.year) {
      this.informeService.getInforme(informe.tipoInforme, informe.year).subscribe({
        next: (response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = 'Casos.xlsx';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["]?([^"]+)["]?/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            }
          }

          const blob = new Blob([response.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Error al obtener la descarga de Casos:', err);
        }
      });
    }
  }
}
